// Title for Events or news or notifications or what so ever

const titleStyle = {
  fontSize: 16,
  fontWeight: 700,
};
export const Title = ({ title, style }) => <div style={{ ...titleStyle, ...style }}>{title}</div>;
